import Input from './Input';
var variants = {
  outline: props => Input.variants.outline(props).field,
  variantFlushed: props => Input.variants.flushed(props).field,
  unstyled: Input.variants.unstyled.field
};
var defaultProps = {
  size: 'md',
  variant: 'outline'
};
export default {
  variants,
  defaultProps
};
//# sourceMappingURL=Textarea.js.map